import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { store } from 'CorePackage/MainModule/common/store';
import { getDirtyAgreementGuid } from 'CorePackage/HeaderModule/reducers/headerReducer';

import { IErknmFormAgreement } from '../interfaces/IErknmFormAgreement';
import { convertViolatedRequirementsFormValuesToKnmData } from './convertViolatedRequirementsFormValuesToKnmData';
import { convertAgreementsApproveFormValuesToData } from './convertAgreementsApproveFormValuesToData';
import { convertAgreementsChangesFormValuesToData } from './convertAgreementsChangesFormValuesToData';
import { convertAgreementsTerminateFormValuesToData } from './convertAgreementsTerminateFormValuesToData';
import { convertAgreementsExecutionFormValuesToData } from './convertAgreementsExecutionFormValuesToData';
import { convertAgreementsPetitionOrganizationFormValuesToData } from './convertAgreementsPetitionOrganizationFormValuesToData';

export const convertAgreementsFormValuesToData = (
  agreements?: IErknmFormAgreement[] | undefined,
): IKnm248['agreements'] => {
  const state = store.getState();
  const dirtyAgreementGuid = getDirtyAgreementGuid(state);

  if (!agreements) return null;

  return agreements?.map(agreement => {
    return {
      status: agreement.status || null,
      isNew: agreement.isNew || null,
      signed: dirtyAgreementGuid && dirtyAgreementGuid === agreement.guid ? false : agreement.signed || null,
      signedFirst: agreement.signedFirst || null,
      guid: agreement.guid || null,
      prescriptionGuid: agreement.prescription?.value || null,
      violations: convertViolatedRequirementsFormValuesToKnmData(agreement.violations),
      petitionOrganizationType: agreement.petitionOrganizationType?.value || null,
      petitionOrganization: convertAgreementsPetitionOrganizationFormValuesToData(agreement.petitionOrganization),
      petitionAttachment: convertKnmDocumentAttachmentsFormValuesToKnmData(agreement.petitionAttachment)?.pop() || null,
      approvalOfAgreement:
        typeof agreement.approvalOfAgreement?.value === 'boolean' ? agreement.approvalOfAgreement?.value : null,
      approvalOfAgreementAttachment:
        convertKnmDocumentAttachmentsFormValuesToKnmData(agreement.approvalOfAgreementAttachment)?.pop() || null,
      eliminateViolationsNumber: agreement.eliminateViolationsNumber || null,
      conclusionDate: convertFormDateValueToKnmDataDate(agreement.conclusionDate),
      eliminateViolationsAttachment:
        convertKnmDocumentAttachmentsFormValuesToKnmData(agreement.eliminateViolationsAttachment)?.pop() || null,
      termOfExecutionAgreement: convertFormDateValueToKnmDataDate(agreement.termOfExecutionAgreement),
      dateOnApprove: convertFormDateValueToKnmDataDate(agreement.dateOnApprove),
      applicationForConsiderationAttachment:
        convertKnmDocumentAttachmentsFormValuesToKnmData(agreement.applicationForConsiderationAttachment)?.pop() ||
        null,
      otherAttachments: convertKnmDocumentAttachmentsFormValuesToKnmData(agreement.otherAttachments) || null,
      violationCorrectionProgramAttachments:
        convertKnmDocumentAttachmentsFormValuesToKnmData(agreement.violationCorrectionProgramAttachments) || null,
      prosecutorOrganization: {
        id:
          !agreement.prosecutorOrganization?.ervkUuid && agreement.prosecutorOrganization?.id
            ? agreement.prosecutorOrganization?.id
            : null,
        code: null,
        name: agreement.prosecutorOrganization?.fullName || null,
        address: null,
        contacts: null,
        federalDistrictId: null,
        regionId: null,
        parentId: null,
        enabled: null,
        ervkUuid: agreement.prosecutorOrganization?.ervkUuid,
        ervkVersionUuid: agreement.prosecutorOrganization?.ervkVersionUuid,
      },
      fioSigner: agreement.fioSigner?.trim() || null,
      titleSigner: agreement.titleSigner?.value || null,
      approveInfo: convertAgreementsApproveFormValuesToData(agreement.approveInfo),
      terminate: convertAgreementsTerminateFormValuesToData(agreement.terminate),
      changes: convertAgreementsChangesFormValuesToData(agreement.changes),
      execution: convertAgreementsExecutionFormValuesToData(agreement.execution),
    };
  });
};
